const map = {
  // 活动结算价管理
  activityManagementList: () =>
    import('@/views/activitySetpriceManagement/activityManagementList'), // 商品价格及库存
  createActivity: () =>
    import('@/views/activitySetpriceManagement/createActivity'), // 创建活动
  viewActivity: () => import('@/views/activitySetpriceManagement/viewActivity') // 查看活动
}

export default map
